import { apiClient } from "@/api/api-client.ts";
import createBaseService, { type Pagination } from "@/api/base-service.ts";
import type { ActivityNote } from "../../types/activity-notes";

const activityNotesService = {
	...createBaseService<ActivityNote>("/case-activity-notes"),
	upsertById: async (data: T) => {
		const response = await apiClient.post<{ data: T }>("/case-activity-notes", data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});

		return response.data.data;
	},
};

export default activityNotesService;
